module.exports = __webpack_public_path__ + "img/index-kinds-signIn.0f37dfb1.png";